/**
 * <bh-next-date> — "Най-ранна дата: утре, сряда 8 октомври" in the announcement bar.
 * Markup and the why: snippets/bh-next-date.liquid.
 *
 * The date comes from a detached <bh-date-picker>: same constructor (reads the closure lists),
 * same _rawReason (lead time, blocked, отработване, holiday, weekly closure, in that order).
 * Never re-implement a date rule here.
 */
if (!customElements.get('bh-next-date')) {
  customElements.define('bh-next-date', class extends HTMLElement {
    connectedCallback() {
      customElements.whenDefined('bh-date-picker').then(() => this.render());
    }

    render() {
      const picker = document.createElement('bh-date-picker'); // not connected: no calendar renders
      picker.minLeadDays = parseInt(this.dataset.minLead, 10) || 0;
      const day = new Date();
      day.setHours(0, 0, 0, 0);
      for (let i = 0; i <= 60; i++) {
        const key = picker._key(day.getFullYear(), day.getMonth(), day.getDate());
        if (picker._rawReason(key) === null) return this.show(day, i);
        day.setDate(day.getDate() + 1);
      }
      // ponytail: nothing bookable in 60 days (a long closure) keeps the static text.
    }

    show(date, inDays) {
      const locale = this.dataset.locale === 'en' ? 'en-GB' : 'bg-BG';
      let when = date.toLocaleDateString(locale, { weekday: 'long', day: 'numeric', month: 'long' });
      if (inDays === 0) when = `${this.dataset.today}, ${when}`; // only if same-day is ever switched on
      if (inDays === 1) when = `${this.dataset.tomorrow}, ${when}`;
      const link = document.createElement('a');
      link.href = this.dataset.href;
      link.textContent = this.dataset.suffix;
      this.replaceChildren(`${this.dataset.label}: ${when} · `, link);
    }
  });
}
